<template>
    <lq-el-form
        @submited-success="submitted"
        name="forget_password"
        auto-complete="off"
        :rules="rules"
        action="delete-account"
    >
        <el-card shadow="always" :style="{overflow: 'initial'}">
            <lq-el-input
                type="email"
                id="email"
                placeholder="Email"
            />
            <lq-el-input id="password" type="password" placeholder="Password" />
            <el-row align="middle" justify="end">
                <el-col :span="12">
                    <lq-el-submit label="Delete Account" />
                </el-col>
            </el-row>
        </el-card>
    </lq-el-form>
</template>
<script>
export default {
    name: 'login-form',
    data: function() {
        return {
            rules: {
                email: {
                    // email: true,
                    presence: {
                        allowEmpty: false,
                        message: 'field is required'
                    },
                    format: {
                        pattern: /(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)|(^\+?([0-9]){1,4}?(\-)?([0-9 \s]){6,12}$)/,
                        message: 'Please enter a valid email.'
                    }
                },
                password: {
                    presence: {
                        allowEmpty: false,
                        message: 'field is required'
                    }
                }
            }
        };
    },
    methods: {
        submitted: function(response) {
            this.$router.push('/', () => {
                this.$message.success({
                    type: 'success',
                    message: response.message
                });
            })
        }
    }
};
</script>

